import React from 'react';
import { Input, Select } from '@common/FormFields';

const STRUCTURE_TYPES = [
  { value: 'pont', label: 'Bridge' },
  { value: 'ponceau', label: 'Culvert' },
  { value: 'tunnel', label: 'Tunnel' },
  { value: 'viaduc', label: 'Viaduct' },
  { value: 'passerelle', label: 'Footbridge' }
];

export const StructuresFilters = ({ filters, onChange }) => {
  return (
    <div className="space-y-4 mb-6">
      <h2 className="text-lg font-medium text-white">Filters</h2>

      {/* Structure Types */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Structure Types
        </label>
        <div className="space-y-2">
          {STRUCTURE_TYPES.map(type => (
            <label key={type.value} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={filters.types.includes(type.value)}
                onChange={(e) => {
                  const newTypes = e.target.checked
                    ? [...filters.types, type.value]
                    : filters.types.filter(t => t !== type.value);
                  onChange({ ...filters, types: newTypes });
                }}
                className="rounded border-gray-600 text-red-600 focus:ring-red-500 bg-gray-700"
              />
              <span className="text-gray-300">{type.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Buffer Distance */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Search Distance (km)
        </label>
        <Input
          type="number"
          value={filters.maxDistance || ''}
          onChange={(e) => onChange({
            ...filters,
            maxDistance: e.target.value ? Number(e.target.value) : 0.5
          })}
          min="0.1"
          max="5"
          step="0.1"
          className="bg-gray-700 border-gray-600 text-white"
        />
        <p className="text-xs text-gray-400 mt-1">
          Distance from route to search for structures (0.1 to 5 km)
        </p>
      </div>

      {/* Minimum Clearance */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Minimum Clearance (m)
        </label>
        <Input
          type="number"
          value={filters.minClearance || ''}
          onChange={(e) => onChange({
            ...filters,
            minClearance: e.target.value ? Number(e.target.value) : null
          })}
          min="0"
          step="0.1"
          className="bg-gray-700 border-gray-600 text-white"
        />
      </div>
    </div>
  );
};